import { z } from "zod"
import { CustomerAddressType } from "@/api/customers"

export const customerFormSchema = z.object({
  firstName: z.string().min(1, { message: "First name is required" }),
  lastName: z.string().min(1, { message: "Last name is required" }),
  email: z.string().email(),
  organizationName: z.string().optional(),
  taxId: z.string().optional(),
  phoneNumber: z.string().optional(),
  addresses: z.array(
    z.object({
      id: z.string().optional(),
      type: z.nativeEnum(CustomerAddressType),
      countryId: z.string().min(1, { message: "Country is required" }),
      stateId: z.string().optional(),
      address: z.string().min(1, { message: "Address is required" }),
      addressExtra: z.string().optional(),
      city: z.string().min(1, { message: "City is required" }),
      postalCode: z.string(),
    }),
  ),
})
